import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const importEstimation = {
    namespaced: true,
    state: {
        isEstimationImporting: [],
    },
    mutations: {
        SUCCESS_UPDATE_ESTIMATION(state, response, item) {
            state.typeInfoEstimationUpdate = "green";
            state.headInfoEstimationUpdate = response.data.message;
            state.textInfoEstimationUpdate = response.data.data.textInfo;
            let dataReceive = {
                title: response.data.message,
                message: response.data.data.textInfo,
                estimation: response.data.data.estimation
            }
            state.isEstimationImporting.splice(state.isEstimationImporting.indexOf(item), 1);

            eventBus.$emit("importEstimationSuccess", (dataReceive));
        },
        FAILURE_UPDATE_ESTIMATION(state, error, item) {
            state.textInfoEstimationUpdate = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoEstimationUpdate = "red";
            state.headInfoEstimationUpdate = error.response.data.message;
            state.isEstimationImporting.splice(state.isEstimationImporting.indexOf(item), 1);
            eventBus.$emit("saveEstimationFailure", error.response.data.errors);
        },
        IMPORT_DATA_REQUEST(state, item) {
            state.isEstimationImporting.push(item);
        },
    },
    actions: {
        importEstimation: function({dispatch}, payload) {
            let url = new URL(window.location.href);
            var promise = sendRequest("post", config.baseURLApi + "/projects/" + url.searchParams.get("id") + "/import-estimation", {}, payload.creds);
            dispatch("requestDataImport", payload.creds.offer_id)
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("importEstimationSuccess", result[1], payload.creds.offer_id);
                } else {
                    dispatch("importEstimationFailure", result[1], payload.creds.offer_id);
                }
            });
        },
        requestDataImport: function({commit}, value) {
            commit("IMPORT_DATA_REQUEST", value);
        },
        importEstimationSuccess: function({commit}, response) {
            commit("SUCCESS_UPDATE_ESTIMATION", response);
        },
        importEstimationFailure: function({commit}, error) {
            commit("FAILURE_UPDATE_ESTIMATION", error);
        },
    }
}

export default importEstimation;